import React from 'react';
const NotFound = () => {
    return (<>Página no encontrada</>)
}

export default NotFound;